import MigrationSetupModal from './migration.setup.modal'

export default MigrationSetupModal
